<template>
    <v-app>
        <div v-if="isAuthorized()">
            <v-dialog v-model="showDialog" max-width="500">
                <v-card>
                    <v-card-title class="headline">{{ msg }}</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="indigo white--text" depressed @click="showDialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="show429Dialog" max-width="500">
                <v-card>
                    <v-card-title class="headline white--text" style="background-color: #c62828;">
                        Too Many Requests
                    </v-card-title>
                    <v-card-text class="pt-4 subtitle-1">{{ msg429 }}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-3 white--text" depressed @click="show429Dialog = false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div id="myHeader">
                <div id="app__header" v-if="!$c.nonHeaderRoute.includes($route.name)">
                    <div id="app__logo" :style="{ backgroundImage: `url(${logo})` }" @click="reload"></div>

                    <div id="app__logout">
                        <v-btn depressed small class="mr-5" color="indigo white--text" @click="goToAdmin()">Admin
                            Portal</v-btn>
                        <v-hover v-slot:default="{ hover }" open-delay="200">
                            <v-icon title="Sign Out" color="indigo white--text" :elevation="hover ? 16 : 2"
                                @click.prevent="signout" left>
                                mdi-power
                            </v-icon>
                        </v-hover>
                    </div>
                </div>
                <v-row>
                    <div id="app__time">
                        <!-- <ul v-if="$route.name == 'home'" id="app__list"> -->
                        <ul v-if="showAppHeader" id="app__list">
                            <li id="app__menu">
                                <v-hover v-slot:default="{ hover }" open-delay="200">
                                    <v-btn depressed small color="indigo white--text"
                                        @click.prevent="dashboard($config.PRIMARY_DASHBOARD)"
                                        :elevation="hover ? 16 : 2">Focus</v-btn>
                                </v-hover>
                                <div class="activetab indigo white--text"
                                    v-if="$store.getters['RawData/getDashboardType'] == 'focus'"></div>
                            </li>
                            <li id="app__menu">
                                <v-hover v-slot:default="{ hover }" open-delay="200">
                                    <v-btn depressed small color="indigo white--text"
                                        @click.prevent="setDashboardType('junk')"
                                        :elevation="hover ? 16 : 2">e-Glacier</v-btn>
                                </v-hover>
                                <div class="activetab indigo white--text"
                                    v-if="$store.getters['RawData/getDashboardType'] == 'junk'"></div>
                            </li>
                        </ul>
                        <b class="bold_font" v-if="$route.name === 'home' && timeTaken !== 'less then 1 sec'">Page
                            render time:{{ timeTaken }}</b>
                    </div>
                </v-row>
                <v-row v-if="displayThis">
                    <div id="app__panelists">
                        <ul id="app__panlist">
                            <li>
                                <v-btn depressed small class="mb-1" color="teal white--text"
                                    @click="copyToClipboard()">Copy</v-btn>
                            </li>
                            <li v-if="$store.getters['RawData/getDashboardType'] != 'junk'">
                                <a :class="getActiveClass('home')" @click="redirectToPanelist('home')">All</a>
                            </li>
                            <li v-if="$store.getters['RawData/getDashboardType'] != 'junk'">
                                <a :class="getActiveClass('producer')" @click="redirectToPanelist('producer')">Producer
                                    Panelists</a>
                            </li>
                            <li v-if="$store.getters['RawData/getDashboardType'] != 'junk'">
                                <a :class="getActiveClass('consumer')" @click="redirectToPanelist('consumer')">Consumer
                                    Panelists</a>
                            </li>
                            <li v-if="$store.getters['RawData/getDashboardType'] != 'junk'">
                                <a :class="getActiveClass('mortgage')" @click="redirectToPanelist('mortgage')">Mortgage
                                    Broker Panelists</a>
                            </li>
                            <li v-if="$store.getters['RawData/getDashboardType'] != 'junk'">
                                <a :class="getActiveClass('provider')" @click="redirectToPanelist('provider')">Provider
                                    Panelists</a>
                            </li>
                        </ul>
                        <span class="mb-3" id="app__panelists--span"
                            v-if="$store.getters['RawData/getDashboardType'] == 'junk'">
                            <div>
                                <v-btn depressed small color="teal white--text" @click.prevent="moveToFocus()">Move To
                                    Focus</v-btn>
                            </div>
                        </span>
                        <span class="mb-3" id="app__panelists--span" v-else>
                            <div>
                                <v-btn depressed small color="teal white--text mr-5" @click.prevent="moveToJunk()">Move
                                    to e-Glacier</v-btn>
                                <v-btn depressed small color="teal white--text"
                                    @click.prevent="updateDetails()">Update</v-btn>
                            </div>
                        </span>
                    </div>
                </v-row>
            </div>
            <RouterView :key="$route.fullPath" />
        </div>

        <div v-if=isUnauthorized>
            <div id="app__logo" :style="{ backgroundImage: `url(${logo})` }" @click="reload"></div>
            <div class="main">
                <div class="w3-display-middle">
                    <h1 class="w3-jumbo w3-animate-top w3-center"><code>Not Authorized</code></h1>
                    <hr class="w3-border-white w3-animate-left" style="margin:auto;width:50%">
                    <h3 class="w3-center w3-animate-right">You are not authorized to access to this site.</h3>
                    <h6 class="w3-center w3-animate-zoom">error code:401 unauthorized</h6>
                </div>
            </div>
        </div>

    </v-app>
</template>

<script>
import Logo from '@/assets/img/logo.png'
import axios from 'axios'
export default {
    name: 'App',
    data() {
        return {
            logo: Logo,
            showDialog: false,
            msg: '',
            isUnauthorized: false,
            fullpage: true,
            show429Dialog: false,   // ADD THIS
            msg429: '',
            // focus_flag: false,
            // junk_flag: false
        }
    },
    mounted() {
        let view = this
        if (this.$utils.isValidToken() === false && this.isPortalAccessEmpty()) {
            view.$utils.setCookies('lastVisitedUrl', location.href, view)
            this.checkSessionExist()
        } else {
            this.isAuthorized()
        }
        window.onscroll = function () {
            let myHeader = document.getElementById("myHeader");
            let emails_headerr = document.getElementById("emails__header");
            let spacey_emails = document.getElementsByClassName("spacyEmails");
            let deduplicatesEmails = document.getElementById("deduplicate__header");
            let app_header = document.getElementById("app__header");
            var document_height = document.body.clientHeight;
            if (window.pageYOffset > 200) {
                if (spacey_emails.length > 0 && document_height > 1200) {
                    myHeader.classList.add("stickyHeader");
                    emails_headerr.classList.add("stickyPrimaryEmail");
                    app_header.classList.add('hideLogoRow');
                }
                else if (emails_headerr && document_height > 1200) {
                    myHeader.classList.add("stickyHeader");
                    emails_headerr.classList.add("stickyEmail");
                    app_header.classList.add('hideLogoRow');

                }
                else if (deduplicatesEmails && document_height > 1200) {
                    myHeader.classList.add("stickyHeader");
                    deduplicatesEmails.classList.add("stickydeDuplicatesEmail");
                    app_header.classList.add('hideLogoRow');
                }
                else if (document_height > 1200) {
                    myHeader.classList.add("stickyHeader");
                }

            } else {
                if (spacey_emails.length > 0) {
                    myHeader.classList.remove("stickyHeader");
                    emails_headerr.classList.remove("stickyPrimaryEmail");
                    app_header.classList.remove('hideLogoRow');
                }
                else if (emails_headerr) {
                    myHeader.classList.remove("stickyHeader");
                    emails_headerr.classList.remove("stickyEmail");
                    app_header.classList.remove('hideLogoRow');
                }
                else if (deduplicatesEmails) {
                    myHeader.classList.remove("stickyHeader");
                    deduplicatesEmails.classList.remove("stickydeDuplicatesEmail");
                    app_header.classList.remove('hideLogoRow');
                }
                else {
                    myHeader.classList.remove("stickyHeader");
                }

            }
        };
    },
    beforeCreate() {
    },
    created() {
        var view = this
        // console.log("created called")
        window.addEventListener('touchstart', () => {
            const currentDate = new Date();
            const startTime = currentDate.getTime();
            view.$utils.setCookies('startTime', startTime, view)
        });
        window.addEventListener('mousemove', () => {
            const currentDate = new Date();
            const startTime = currentDate.getTime();
            view.$utils.setCookies('startTime', startTime, view)

        });
        window.addEventListener('mousedown', () => {
            const currentDate = new Date();
            const startTime = currentDate.getTime();
            view.$utils.setCookies('startTime', startTime, view)

        });
        window.addEventListener('keydown', () => {
            const currentDate = new Date();
            const startTime = currentDate.getTime();
            view.$utils.setCookies('startTime', startTime, view)

        });
        this.interval = setInterval(() => this.idleredirect(), 60000);  //watcher for auto logout  
        this.interval = setInterval(() => this.refreshToken(), 60000);
        this.interval = setInterval(() => this.signoutRedirectForSubdomainApps(), 1000); //watcher for manual logout 
        if (this.$utils.isValidToken() === true) {
            this.getRolesAndPermissionData();
        }
    },
    computed: {
        dashboardType: function () {
            return this.$store.getters['RawData/getDashboardType'];
        },
        timeTaken: function () {
            let endTime = parseInt(this.$store.getters['Emails/getEndTime'])
            let startTime = parseInt(this.$store.getters['Emails/getStartTime'])
            let timeTaken = endTime === 0 ? 0 : endTime - startTime
            let t = timeTaken < 0 ? 0 : (timeTaken / 1000)
            return t < 1 ? 'less than 1 sec' : t.toFixed(2) + ' sec'
        },
        getDashboard: function () {
            return this.$store.getters['Display/getDisplayDashboard']
        },
        showAppHeader: function () {
            return this.$utils.showAppHeader(this)
        },
        displayThis: function () {
            return this.getDashboard === this.$config.PRIMARY_DASHBOARD && this.showAppHeader
        },
    },
    methods: {
        setDashboardType(type) {
            var view = this;
            // if (type === "focus") {
            //     console.log
            //     view.focus_flag =true
            //  }
            //  else if (type === "junk") {
            //     view.junk_flag =true
            // }
            view.$store.dispatch('Emails/removeAllUpdateObj', [])
            //this.$utils.setCookies('dashboardType', type, this)
            view.$store.dispatch('RawData/setDashboardType', type)
            //this.$forceUpdate();
            let dashboardType = view.$store.getters['RawData/getDashboardType'];

            if (dashboardType == 'junk') {
                view.$store.dispatch("Search/setSHOWEMAILTYPEJUNK", true);
                view.$store.dispatch("Search/setSHOWEMAILTYPEBLANK", false);
                view.$store.dispatch("Search/setSHOWEMAILTYPEUNUSED", false);
                view.$store.dispatch("Search/setSHOWEMAILTYPEUSED", false);
                view.$store.dispatch("Search/setSHOWEMAILTYPECOPY", false);
                view.redirectToPanelist('home')
            } else if (dashboardType == 'focus') {
                view.$store.dispatch("Search/setSHOWEMAILTYPEJUNK", false);
                view.$store.dispatch("Search/setSHOWEMAILTYPEBLANK", true);
                view.$store.dispatch("Search/setSHOWEMAILTYPEUNUSED", true);
                view.$store.dispatch("Search/setSHOWEMAILTYPEUSED", false);
                view.$store.dispatch("Search/setSHOWEMAILTYPECOPY", false);
            }
            view.$store
                .dispatch("Emails/setPage", 1)
                .then(function () {
                    return view.$store.dispatch("Emails/setPerPage", 10);
                })
                .then(function () {
                    view.$store
                        .dispatch("Emails/setSortingDirection", "desc")
                        .then(function () {
                            view.$store
                                .dispatch("Emails/setSortingField", "email_date")
                                .then(function () {
                                    if (view.$store.getters['Emails/getRequestPayloadPanelist'] != 'home') {
                                        view.redirectToPanelist('home')
                                    }
                                    return view.$utils.search(view)
                                })
                                .catch(function (e) {
                                    if (e && (e.is429 || e.status === 429 || (e.response && e.response.status === 429))) {
                                        view.handle429(e);
                                    } else {
                                        console.log(e);
                                    }
                                });
                            //         .then(function (promise_res) {
                            //         if (promise_res === true) {
                            //         if (type === "focus") {
                            //             view.focus_flag = false;
                            //         }
                            //         else if (type === "junk") {
                            //             view.junk_flag = false;
                            //         }
                            //         }
                            // });
                        });
                });
        },
        goToAdmin() {
            var view = this;
            window.open(
                view.$url("ADMIN_FRONTEND_URL"),
                "_blank"
            );
            window.focus();
        },
        getRolesAndPermissionData: async function () {
            let check = this
            let json_data = {}
            let complete_sidebar = []
            let path = this.$url("ROLE_PERMISSION_URL") + '/2'

            await check.$store.dispatch("RawData/setCurrentActiveModule", null)

            try {
                let res = JSON.parse(localStorage.getItem("role_permission"))
                if (!res) {
                    res = await this.$fetch({
                        url: path,
                        type: "GET",
                    }, {
                        operation: 'view',
                        vueScope: check,
                    })
                    localStorage.setItem('role_permission', JSON.stringify(res))
                }

                let current_active_mod = null
                json_data = res.payload

                check.$store.dispatch("RawData/setUserId", json_data.user_id)

                if (json_data.user_role) {
                    let user_role = json_data.user_role
                    let link_names = []

                    this.$utils.setCookies('user_role', user_role.role_id, this)

                    if (user_role.sectors.length) {
                        await check.$store.dispatch("RawData/setAllowedSectors", user_role.sectors)
                    }

                    if (user_role.modules.length) {
                        user_role.modules.forEach(module => {
                            let sidebar_module = {
                                icon: module.module_icon,
                                title: module.module_name,
                                to: "/" + module.module_url_slug.trim(),
                                module_sort: module.module_sort,
                                module_parent_id: module.module_parent_id,
                                module_id: module.module_id,
                                operations: module.operations,
                            }

                            if (!link_names.includes(sidebar_module.title)) {
                                if (
                                    check.$route.path.toLowerCase() === '/' &&
                                    check.$route.path.toLowerCase() === sidebar_module.to.toLowerCase() &&
                                    current_active_mod === null
                                ) {
                                    current_active_mod = sidebar_module
                                } else if (
                                    check.$route.path.toLowerCase() !== '/' &&
                                    sidebar_module.to.toLowerCase() !== '/' &&
                                    check.$route.path.toLowerCase().includes(sidebar_module.to.toLowerCase()) &&
                                    current_active_mod === null
                                ) {
                                    current_active_mod = sidebar_module
                                }
                                link_names.push(sidebar_module.title)
                                complete_sidebar.push(sidebar_module)
                            }
                        })
                    }

                    complete_sidebar = complete_sidebar.sort(
                        (a, b) =>
                            a.module_sort > b.module_sort ? 1 : b.module_sort > a.module_sort ? -1 : 0
                    )
                    await check.$store.dispatch("RawData/setSidebar", complete_sidebar)

                    if (!current_active_mod) {
                        alert("You are not authorized!")
                        if (check.$route.path.toLowerCase() === '/') {
                            check.signout()
                        } else {
                            location.href = window.location.origin
                        }
                    }

                    await check.$store.dispatch("RawData/setCurrentActiveModule", current_active_mod)
                }
            } catch (error) {
                console.error(error)
            }
        },
        redirectToPanelist: async function (pan) {
    var view = this;
    try {
        await view.$store.dispatch('Emails/setRequestPanelist', pan);
        await view.$store.dispatch('Search/setPanelistType', pan);

        await view.$router.replace({
            name: pan,
            params: {
                isFromSearch: view.$store.getters['Search/getIsFromSearch'],
                search: view.$store.getters['Search/getState']
            }
        });

    } catch (e) {
        if (e && (e.is429 || e.status === 429 || (e.response && e.response.status === 429))) {
            view.handle429(e);
        } else {
            console.log(e);
        }
    }
},
        idleredirect: function () {
            let view = this
            const currentDate = new Date();
            const currentTime = currentDate.getTime();
            const diff = currentTime - parseInt(this.$utils.getCookies('startTime'))
            if (diff >= 1500000) {
                let auto_signout_url = this.$url('AUTO_SIGNOUT_URL')
                view.$fetch({
                    url: auto_signout_url,
                    type: "GET"
                }, {
                    operation: 'view',
                    vueScope: view
                }).then(res => {
                    this.$utils.removeCookies('access_token', this)
                    this.$utils.removeCookies('portal_access', this)
                    this.$utils.removeCookies('email', this)
                    this.$utils.removeCookies('username', this)
                    this.$utils.removeCookies('user_id', this)
                    this.$utils.removeCookies('un_pass', this)
                    this.$utils.removeCookies('refresh_token', this)
                    this.$utils.removeCookies('portal_access', this)
                    this.$utils.removeCookies('token_expire_time', this)
                    this.$utils.removeCookies('startTime', this)
                    this.$utils.removeCookies('precedence_url', this)
                    this.$utils.removeCookies('dashboardType', this)
                    this.$utils.setCookies('isActive', false, this)
                    this.$utils.setCookies('lastVisitedUrl', location.origin + this.$router.history.current.path, this)
                    //this will redirect to login
                    location.href = this.$url('SIGNIN_URL')
                    if (res.data.statusCode === 200) {
                        //
                    }
                }).catch((error) => {
                    console.error(error);
                });
            }
        },
        //This will redirect to signin page if you logged out from any of the page or subdomain application
        signoutRedirectForSubdomainApps: function () {
            if (this.$utils.getCookies('isSignedIn') === 'false' && !this.isUnauthorized) {
                location.href = this.$url('SIGNIN_URL')
            }
        },
        refreshToken: function () {
            var currentDate = new Date();
            let currentTimeInMiliseconds = currentDate.getTime();
            let expireTimeInmiliseconds = this.$utils.getCookies('token_expire_time')
            if (expireTimeInmiliseconds != null && expireTimeInmiliseconds != 'undefined') {
                if (currentTimeInMiliseconds > expireTimeInmiliseconds) {
                    let refresh_token_url = this.$url('REFRESH_TOKEN_URL')
                    axios.get(refresh_token_url, {
                        headers: {
                            Authorization: this.$utils.getCookies('refresh_token'),
                            Username: this.$utils.getCookies('username'),
                            userid: this.$utils.getCookies('user_id')
                        }
                    }).then(res => {
                        //console.log("refresh token called")
                        if (res.data.statusCode == 200) {
                            this.$utils.setCookies('access_token', res.data.payload.access_token, this)
                            //set expire time of access token
                            var currentdate = new Date();
                            let minutes = (res.data.payload.access_token_expire_time / 60) - 5
                            let expire_time = currentdate.setTime(currentdate.getTime() + (minutes * 60 * 1000));
                            this.$utils.setCookies('token_expire_time', expire_time, this)
                        } else {
                            this.$utils.setCookies('isActive', false, this)
                            this.$utils.removeCookies('access_token', this)
                            this.$utils.setCookies('lastVisitedUrl', location.origin + this.$router.history.current.path, this)
                            if (confirm("Your session has expired, please login again")) {
                                location.href = this.$url('SIGNIN_URL')
                            } else {
                                location.href = this.$url('SIGNIN_URL')
                            }
                        }
                    }).catch((error) => {
                        console.error(error);
                        this.$utils.setCookies('isActive', false, this)
                        this.$utils.removeCookies('access_token', this)
                        this.$utils.setCookies('lastVisitedUrl', location.origin + this.$router.history.current.path, this)
                        if (confirm("Your session has expired, please login again")) {
                            location.href = this.$url('SIGNIN_URL')
                        } else {
                            location.href = this.$url('SIGNIN_URL')
                        }
                    });
                }
            }
        },
        reload: function () {
            window.location.href = '/'
        },
        getActiveClass: function (r) {
            return this.$route.name === r ? 'active_panelist' : ''
        },
        dashboard: function (dashboard) {
            var view = this
            this.setDashboardType('focus');
            return view.$store.dispatch('Emails/setPerPage', parseInt(10))
                .then(function () {
                    return view.$store.dispatch('Emails/setPage', parseInt(1));
                })
                .then(function () {
                    return view.$store.dispatch('Display/setDisplayDashboard', dashboard);
                })
                .catch(function (e) {
                    if (e && (e.is429 || e.status === 429 || (e.response && e.response.status === 429))) {
                        view.handle429(e);
                    } else {
                        console.log(e);
                    }
                });
        },
        spacey: function () {
            var view = this
            view.$store.dispatch('Emails/setPerPage', parseInt(10)).then(function () {
                return view.$store.dispatch('Emails/setPage', parseInt(1))
            }).then(function () {
                view.$store.dispatch('Display/setDisplayDashboard', view.$config.SPACEY_DASHBOARD)
            })
            localStorage.setItem('selected_dashboard', this.$config.SPACEY_DASHBOARD)
        },
        deduplicates: function (dashboard) {
            var view = this
            view.$store.dispatch('Deduplicate/setPerPage', parseInt(10)).then(function () {
                return view.$store.dispatch('Deduplicate/setPage', parseInt(1))
            }).then(function () {
                view.$store.dispatch('Display/setDisplayDashboard', dashboard)
            })
        },
        moveToFocus: function () {
            //console.log('move to focus');
            var view = this
            let selected_ids = this.$store.getters["Emails/getIdsToUpdate"]
            selected_ids.forEach((muid) => {
                this.$store.dispatch("Emails/updateStatusByMuid", {
                    muid: muid,
                    deleted: 0,
                });
            })
            let data = view.$store.getters['Emails/getUpdateObjects']
            if (data.length > 0) {
                view.$store.dispatch('RawData/setBigLoading', true, true)
                view.$utils.updateEmailDetails(view, true, true)
            } else {
                this.msg = 'Please select atleast one email.'
                this.showDialog = true
            }
        },
        moveToJunk: function () {
            //console.log('move to junk');
            var view = this
            let used_copy_count = []
            let data = view.$store.getters['Emails/getUpdateObjects']
            data.forEach((email) => {
                if (email.deleted == 2 || email.deleted == 4) {
                    used_copy_count.push(1)
                }
            })
            if (used_copy_count.length) {
                view.$swal.fire({
                    position: "bottom-end",
                    icon: "error",
                    title: "You have selected some emails which have used and copy status",
                });
            } else {
                let selected_ids = this.$store.getters["Emails/getIdsToUpdate"]
                selected_ids.forEach((muid) => {
                    this.$store.dispatch("Emails/updateStatusByMuid", {
                        muid: muid,
                        deleted: 3,
                    });
                })
                let data = view.$store.getters['Emails/getUpdateObjects']
                if (data.length > 0) {
                    view.$store.dispatch('RawData/setBigLoading', true)
                    view.$utils.updateEmailDetails(view, true, true)
                } else {
                    this.msg = 'Please select atleast one email.'
                    this.showDialog = true
                }
            }
        },
        updateDetails: function () {
            let view = this
            let data = view.$store.getters['Emails/getUpdateObjects'];
            if (data.length > 0) {
                // let checkedRev = view.$store.getters['RawData/getCheckboxData'];
                view.$store.dispatch('RawData/setBigLoading', true)
                // view.$store.dispatch('RawData/setCheckboxData', !checkedRev)
                view.$utils.updateEmailDetails(view, true)
            } else {
                this.msg = 'Please select atleast one email.'
                this.showDialog = true
            }
        },
        signout: function () {
            var view = this
            try {
                let signout_url = view.$url('SIGNOUT_URL')
                axios.get(signout_url, {
                    headers: {
                        Authorization: this.$utils.getCookies('access_token'),
                        Userid: this.$utils.getCookies('user_id')
                    }
                }).then(res => {
                    if (res.data.statusCode === 200) {
                        view.$utils.setCookies('isSignedIn', false, view)
                        view.$utils.removeCookies('access_token', view)
                        view.$utils.removeCookies('email', view)
                        view.$utils.removeCookies('username', view)
                        view.$utils.removeCookies('user_id', view)
                        view.$utils.removeCookies('un_pass', view)
                        view.$utils.removeCookies('refresh_token', view)
                        view.$utils.removeCookies('portal_access', view)
                        view.$utils.removeCookies('token_expire_time', view)
                        view.$utils.removeCookies('startTime', view)
                        view.$utils.removeCookies('precedence_url', view)
                        view.$utils.removeCookies('dashboardType', this)
                        view.$utils.setCookies('lastVisitedUrl', location.origin + view.$router.history.current.path, view)
                        location.href = view.$url('SIGNIN_URL')
                    }
                }).catch((error) => {
                    console.error(error);
                    view.$utils.setCookies('isSignedIn', false, view)
                    view.$utils.removeCookies('access_token', view)
                    view.$utils.removeCookies('lastVisitedUrl', view)
                    view.$utils.removeCookies('email', view)
                    view.$utils.removeCookies('username', view)
                    view.$utils.removeCookies('user_id', view)
                    view.$utils.removeCookies('un_pass', view)
                    view.$utils.removeCookies('refresh_token', view)
                    view.$utils.removeCookies('portal_access', view)
                    view.$utils.removeCookies('token_expire_time', view)
                    view.$utils.removeCookies('startTime', view)
                    view.$utils.removeCookies('precedence_url', view)
                    view.$utils.removeCookies('dashboardType', this)
                    location.href = view.$url('SIGNIN_URL')
                });
                localStorage.removeItem('product_rawdata')
                localStorage.removeItem('role_permission')
            } catch (error) {
                console.log('error signing out: ', error)
            }
        },
        copyToClipboard: function () {
            var view = this,
                refs = view.$store.getters['RawData/getEmailsItemRefs'],
                toupdate = view.$store.getters['Emails/getUpdateObjects'],
                links = []
            if (toupdate.length > 0) {
                toupdate.forEach(function (o) {
                    let index = refs.findIndex(e => e.getId() === o.muid)
                    if (index > -1) {
                        links.push({
                            'link': window.location.origin + refs[index].link,
                            'subject': refs[index].email.email_subject,
                            'muid': o.muid
                        })
                    }
                })
                view.copyString(links)
                view.copyString(links)
                view.copyString(links)
                alert('copied to clipboard.')
            } else {
                this.msg = 'Please select atleast one email.'
                this.showDialog = true
            }
        },
        handle429: function (e) {
            let message = "Too many requests. Please wait a moment and try again.";
            if (e && e.message) {
                message = e.message;
            } else if (e && e.response) {
                message = e.response.data?.message || e.response.data || message;
            }
            this.msg429 = message;
            this.show429Dialog = true;
        },
        copyString: function (links) {
            let s = '',
                div = '',
                range = document.createRange()
            if (links !== null && links.length > 0) {
                links.forEach(o => s = s + '<a href="' + o.link + '">' + o.subject + '</a> - (tempid - ' + o.muid + ') <br/>')
            }
            if (document.getElementById('copy_to_clipboard') === null) {
                div = document.createElement('div'),
                    div.setAttribute('id', 'copy_to_clipboard')
                document.body.appendChild(div)
            }
            div = document.getElementById('copy_to_clipboard')
            div.innerHTML = ''
            div.innerHTML = s
            range.selectNode(div)
            window.getSelection().addRange(range)
            document.execCommand('copy')
            document.body.removeChild(div)
            window.getSelection().removeAllRanges()
        },
        isAuthorized: function () {
            let authorized = false
            let accessList = []
            let urls = this.$utils.getCookies('portal_access')
            if (urls != 'undefined' && urls != null && urls.indexOf(',') > -1) {
                accessList = urls.split(",")
            } else {
                accessList = urls
            }
            var currentUrl = location.origin + '/'
            if (accessList.includes(currentUrl)) {
                if (this.$utils.isValidToken()) {
                    authorized = true
                } else {
                    this.checkSessionExist()
                }
            } else {
                this.isUnauthorized = true
            }
            return authorized
        },
        isPortalAccessEmpty: function () { //when user login and redirects to portal
            let isEmpty = false
            let urls = this.$utils.getCookies('portal_access')
            if (urls === 'undefined' || urls === null || urls.length === 0) {
                isEmpty = true
            }
            return isEmpty
        },
        checkSessionExist: function () {
            let view = this
            if (view.$utils.getCookies('isActive') === 'false') {
                alert("Your session has expired, please login again")
                location.href = this.$url('SIGNIN_URL')
            } else if (view.$utils.getCookies('isSignedIn') === 'false') {
                alert("You have been logged out, please login again")
                location.href = this.$url('SIGNIN_URL')
            } else {
                location.href = this.$url('SIGNIN_URL')
            }
        }
    }
}
</script>

<style lang="sass">
    @import "./assets/sass/app.sass"
</style>
<style scoped>
h1 {
    color: red;
}

h6 {
    color: red;
    text-decoration: underline;
}

.main {
    position: absolute;
    width: 300px;
    height: 200px;
    z-index: 15;
    top: 50%;
    left: 50%;
    margin: -100px 0 0 -150px;
    /* background: red; */
}
</style>
